import { makeStyles } from '@material-ui/core';

const useInviteStyles = makeStyles((theme) => {
  const mobileBreakpoint = theme.breakpoints.down("sm");

  return {
    leftAlignment: {
      position: "fixed",
      bottom: 120,
      left: -10,
      m: 0,
    },
    inviteDialog: {
      minWidth: "360px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexFlow: "column",
      borderBottom: "solid 8px var(--teal-blue)",
      "& label": {
        marginRight: "8px",
        fontSize: "0.9rem",
      },
      "& a": {
        fontSize: "0.9rem",
        textDecoration: "underline",
      },
    },
    inviteDialogTitle: {
      position: "relative",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      textAlign: "center",
      padding: "12px 20px",
      backgroundColor: "var(--teal-blue)",
      color: "white",
    },
    inviteDialog_listItems: {
      margin: '15px 0px 0px 30px'
    },
    button: {
      display: 'flex',
      color: '#007DB8',
      lineHeight: '55px',
      alignItems: 'center',
      justifyContent: 'flex-start',
      textTransform: 'capitalize',
      paddingLeft: '16px',
      fontWeight: 400
    },  
    icon: {
      width: 'var(--menu-link-icon-dim)',
      height: 'var(--menu-link-icon-dim)',
      color: 'var(--cerulean)',
      marginRight: '15px',
      '& > g, & > path': {
        strokeWidth: '1.75'
      }
    },
    errorIcon: {
      fill: '#B71C1C'
    },
    warningIcon: {
      fill: '#EF6C00'
    },
    btn_primary: {
      color: 'var(--white)',
      backgroundColor: 'var(--teal-blue)',
      '&:hover': {
        color: 'var(--white)',
        backgroundColor: 'var(--teal-blue)',
      }
    },
    btn_disabled: {
      color: 'var(--neutrals-black)',
      border: '1px solid var(--disabled)',
      backgroundColor: 'var(--disabled)'
    },
    titleIcon: {
      color: 'var(--warning-orange)',
      verticalAlign: "bottom"
    },
    countryCode: {
      "& label": {
        marginTop: "3px",
      },
    },
    contentClass: {
      display: "flex",
      flexDirection: "column",
      flexBasis: "75%",
      flex: "1",
      [mobileBreakpoint]: {
        margin: "0px",
        width: "100%",
      },
    },
    modalBox:  {
      position: 'absolute' as 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 536,
      backgroundColor: "white",
      borderRadius: '4px',
      [mobileBreakpoint]: {
        width: '20em',
        height: 'auto',
        paddingBottom: '10px',
      },
    },
    boxContent: {
      padding: "25px !important",
    },
    contentText: {
      fontWeight: 500,
      [mobileBreakpoint]: {
        paddingBottom: '0px !important',
      },
    },
    btnContainer: {
      display: 'flex',
      gap: '1em',
      justifyContent: 'flex-end',
      margin: '1em',
    },
    card: {
      display: 'flex',
      padding: '16px 16px 8px 16px',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: '10px',
      alignSelf: 'stretch',
      borderRadius: '4px',
      background:' var(--neutrals-grey-100, #F5F5F5)',
      marginTop: '16px'
    },
    cardItem: {
      padding: '8px 0',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      '&:not(:last-child)': {
        borderBottom: '1px solid var(--neutrals-grey-300, #E0E0E0)'
      }
      
    },
    cardHeader: {
      color: 'var(--neutrals-grey-900, #212121)',
      fontFamily: 'Roboto',
      fontSize: '16px',
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: '22px'
    },
    cardItemHeader: {
      color: 'var(--neutrals-grey-900, #212121)',
      fontFamily: 'Roboto',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: '20px',
    },
    cardItemContent: {
      color: 'var(--neutrals-grey-600, #757575)',
      fontFamily: 'Roboto',
      fontSize: '12px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '16px',
    },
    removeCollabModal: {
      display: 'flex',
      padding: '8px',
      flexDirection: 'column',
      alignItems: 'flex-end',
      gap: '24px'
    },
    heading: {
      display: 'flex',
      alignItems: 'center',
      gap: '10px'
    },
    modalContent: {
      display: 'flex',
      padding: '16px',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: '10px',
      alignSelf: 'stretch'
    },
    heroButton: {
      display: 'flex',
      height: 32,
      padding: '8px 12px',
      gap: 8,
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: 4,
      border: '2px solid #FFFFFF',
      backgroundColor: 'transparent',
      color: '#FFFFFF',
      textTransform: 'none',
      minWidth: 'auto',
      boxShadow: 'none',
      '&:hover': {
        backgroundColor: 'rgba(255,255,255,0.08)',
        border: '2px solid #FFFFFF',
        boxShadow: 'none'
      }
    },
    heroText: {
      fontSize: 14,
      fontWeight: 500,
      lineHeight: '20px',
      fontFamily: 'Roboto',
      color: '#FFFFFF',
      alignItems: 'center'
    },
    heroIcon: {
      width: 16,
      height: 16,
      filter: 'brightness(0) invert(1)'
    }
  }
});

export default useInviteStyles;
